import fetcher from 'api/fetcher';

import urlParser from 'bloko/common/urlParser';

interface Vacancy {
    vacancyId: number;
    name: string;
    areaName: string;
    foreignArea: boolean;
}

type FetchVacancies = (isEmployer: boolean, filterValue?: string) => Promise<Vacancy[]> | [];

const fetchActiveVacancies: FetchVacancies = (isEmployer, filterValue = '') => {
    const params: Record<string, string> = {};
    if (!isEmployer) {
        return [];
    }
    if (filterValue) {
        params.nameFilter = filterValue;
    }
    const queryStr = urlParser.stringify(params);
    return fetcher
        .get<unknown, Vacancy[]>(`/api/v1/vacancy/active_vacancies?${queryStr}`)
        .then((vacancies) => vacancies)
        .catch(() => []);
};

export default fetchActiveVacancies;
